import FormatUtils from '@front/squirtle/utils/format'

const verifyDate = (values, path) => _.get(values, path)
  ? FormatUtils.formatDateFrontToBack(_.get(values, path))
  : undefined

class Callbacks {
  static getEmptyFormHandler() {
    return function getEmptyForm() {
      return
    }
  }

  static recordToFormHandler() {
    return function recordToForm(record) {
      const billing_driver_comment = _.head(_.find(record?.events, ['name', 'driver_comment'])?.data)?.value

      return {
        returnAt: record?.returnAt,
        info: {
          duration: _.get(record, 'info.duration') || 0
        },
        user: {
          user_id: _.get(record, 'do.user_id'),
          client_number: _.get(record, 'do.customerinfo.client_number'),
          contract: _.get(record, 'service.contract'),
          service: _.get(record, 'service.companyservice_id'),
        },
        job: {
          dispatchedAt: _.get(record, 'job.dispatchedAt'),
          payment: {
            fees: record?.job?.payment?.fees,
            base: record?.job?.payment?.base,
            prepaid: record?.job?.payment?.prepaid,
            handling: record?.job?.payment?.handling,
            duration_amount: record?.job?.payment?.duration_amount,
            driver_package_fee: record?.job?.payment?.driver_package_fee,
            option_amount: record?.job?.payment?.option_amount,
            discount_amount: record?.job?.payment?.discount_amount,
            markup_amount: record?.job?.payment?.markup_amount
          }
        },
        loads: {
          src_contact: _.head(record?.loads)?.src_contact,
        },
        assigned_transport: {
          info: {
            dispatchedAt: _.get(record, 'assigned_transport.info.dispatchedAt'),
            arrivedAt: _.get(record, 'assigned_transport.info.arrivedAt'),
            departurePickedAt: _.get(record, 'assigned_transport.info.departurePickedAt'),
            departureDropoffAt: _.get(record, 'assigned_transport.info.departureDropoffAt'),
            returnPickedAt: _.get(record, 'assigned_transport.info.returnPickedAt'),
            returnDropoffAt: _.get(record, 'assigned_transport.info.returnDropoffAt'),
            night: _.get(record, 'assigned_transport.info.night'),
            effective_handling_duration: _.get(record, 'assigned_transport.info.effective_handling_duration'),
            billed_handling_duration: _.get(record, 'assigned_transport.info.billed_handling_duration'),
            duration: _.get(record, 'assigned_transport.info.duration') || 0,
          },
          payment: {
            fees: record?.assigned_transport?.payment?.fees,
            base: record?.assigned_transport?.payment?.base,
            prepaid: record?.assigned_transport?.payment?.prepaid,
            handling: record?.assigned_transport?.payment?.handling,
            discount_amount: record?.assigned_transport?.payment?.discount_amount,
            voucher_amount: record?.assigned_transport?.payment?.voucher_amount,
            duration_amount: record?.assigned_transport?.payment?.duration_amount,
            option_amount: record?.assigned_transport?.payment?.option_amount,
            service_amount: record?.assigned_transport?.payment?.service_amount,
            driver_package_fee: record?.assigned_transport?.payment?.driver_package_fee
          }
        },
        customer_ref: _.get(record, 'customer_ref'),
        order_doc: _.get(record, 'order_doc'),
        included_waiting_minute: _.get(record, 'specific_parameter.included_waiting_minute') || 0,
        load_count: _.get(record, 'assigned_transport.passenger_count') || _.get(record, 'assigned_transport.package_count'),
        payment_ref: _.get(record, 'payment_ref'),
        billing_status: _.get(record, 'billing_status'),
        billing_customer_comment: _.get(record, 'billing_customer_comment'),
        billing_group_comment: _.get(record, 'billing_group_comment'),
        billing_driver_comment
      }
    }
  }
  static recordToStateHandler() {
    return function recordToState(record) {
      return {
        hasJobPayment: !!_.get(record, 'job.payment'),
        transport_id: _.get(record, 'assigned_transport.transport_id'),
        load_type: _.get(record, 'commercial_package.load_type'),
        isB2B: !!_.get(record, 'service'),
        ridemode_id: _.get(record, 'mode')
      }
    }
  }
  static formToRecordHandler() {
    return function formToRecord(values, extra, meta, { load_type, transport_id, ...state }) {
      return _.merge({},
        !!transport_id ? {
          assigned_transport: {
            passenger_count: load_type === 'user' ? _.get(values, 'load_count') : undefined,
            package_count: load_type === 'package' ? _.get(values, 'load_count') : undefined,
            info: {
              dispatchedAt: verifyDate(values, 'assigned_transport.info.dispatchedAt'),
              arrivedAt: verifyDate(values, 'assigned_transport.info.arrivedAt'),
              departurePickedAt: verifyDate(values, 'assigned_transport.info.departurePickedAt'),
              departureDropoffAt: verifyDate(values, 'assigned_transport.info.departureDropoffAt'),
              returnPickedAt: verifyDate(values, 'assigned_transport.info.returnPickedAt'),
              returnDropoffAt: verifyDate(values, 'assigned_transport.info.returnDropoffAt'),
              startedAt: verifyDate(values, 'assigned_transport.info.startedAt'),
              night: _.get(values, 'assigned_transport.info.night'),
              effective_handling_duration: _.get(values, 'assigned_transport.info.effective_handling_duration'),
              billed_handling_duration: _.get(values, 'assigned_transport.info.billed_handling_duration'),
              duration: _.get(values, 'assigned_transport.info.duration'),
            },
            payment: {
              fees: values?.assigned_transport?.payment?.fees,
              base: values?.assigned_transport?.payment?.base,
              prepaid: values?.assigned_transport?.payment?.prepaid,
              handling: values?.assigned_transport?.payment?.handling,
              discount_amount: values?.assigned_transport?.payment?.discount_amount,
              duration_amount: values?.assigned_transport?.payment?.duration_amount,
              driver_package_fee: values?.assigned_transport?.payment?.driver_package_fee,
              option_amount: values?.assigned_transport?.payment?.option_amount,
              service_amount: values?.assigned_transport?.payment?.service_amount,
            }
          },
        } : {}, {
        job: {
          payment: {
            fees: values?.job?.payment?.fees,
            base: values?.job?.payment?.base,
            prepaid: values?.job?.payment?.prepaid,
            handling: values?.job?.payment?.handling,
            duration_amount: values?.job?.payment?.duration_amount,
            driver_package_fee: values?.job?.payment?.driver_package_fee,
            option_amount: values?.job?.payment?.option_amount,
            discount_amount: values?.job?.payment?.discount_amount,
            markup_amount: values?.job?.payment?.markup_amount
          }
        },
        billing_status: _.get(values, 'billing_status'),
        customer_ref: _.get(values, 'customer_ref'),
        payment_ref: _.get(values, 'payment_ref'),
        order_doc: _.get(values, 'order_doc'),
        info: {
          duration: _.get(values, 'info.duration')
        },
        service: _.get(values, 'user.service'),
        do: _.get(values, 'user.user_id'),
        billing_customer_comment: _.get(values, 'billing_customer_comment'),
        billing_group_comment: _.get(values, 'billing_group_comment'),
      }, !!values?.loads?.src_contact ? {
        loads: {
          src_contact: _.get(values, 'loads.src_contact')
        }
      } : {})
    }
  }
  static formToOptionsHandler() {
    return function formToOptions(values, extra, meta, state) {
      return ({
        load_type: _.get(state, 'load_type'),
        load_count: _.get(values, 'load_count'),
      })
    }
  }

  static onSubmitSuccessHandler() {
    return function onSubmitSuccess(result, values, extra, meta, state) {
      console.log("🚀 ~ file: callbacks.js ~ line 166 ~ Callbacks ~ onSubmitSuccess ~ result", result)
    }
  }
  static onSubmitFailedHandler() {
    return function onSubmitFailed(err, values, extra, meta, state) {
      console.log("🚀 ~ file: callbacks.js ~ line 171 ~ Callbacks ~ onSubmitFailed ~ err", err)
    }
  }

}

export default Callbacks
